import { Button } from "@/shared/components/ui/button"
import { AddChildDialog } from "./AddChildDialog"

export function EmptyChildrenState() {
  return (
    <div className="flex min-h-full flex-col items-center justify-center gap-4 p-6 text-center">
      <p className="text-muted-foreground">Lägg till ett barn för att börja</p>
      <AddChildDialog trigger={<Button>Lägg till barnprofil</Button>} />
    </div>
  )
}
